import React from 'react';
import PropTypes from 'prop-types';
import { CircleSpinner } from '../../../assets/svg';

export const ButtonComponent = ({
    className,
    children,
    text = '',
    type = 'button',
    id = '',
    disabled,
    clickHandler = () => {},
    bootstrapButton: BootstrapButton,
    ariaControls,
    ariaExpanded,
    isLoading = false,
    ...props
}) => {
    return (
        <>
            {BootstrapButton ? (
                <BootstrapButton
                    className={className + ` position-relative ${isLoading ? 'text-muted' : ''}`}
                    onClick={() => clickHandler(!ariaExpanded)}
                    type={type}
                    {...(id && { id: id })}
                    aria-expanded={ariaExpanded}
                    aria-controls={ariaControls}
                    {...props}
                    disabled={disabled || isLoading}
                >
                    {text ? text : children}
                    {isLoading && <CircleSpinner absolute size='1.2rem' />}
                </BootstrapButton>
            ) : (
                <button
                    className={className + ` position-relative ${isLoading ? 'text-muted' : ''}`}
                    onClick={clickHandler}
                    type={type}
                    id={id}
                    disabled={disabled || isLoading}
                    {...props}
                >
                    {text ? text : children}
                    {isLoading && <CircleSpinner absolute size='1.2rem' />}
                </button>
            )}
        </>
    );
};

ButtonComponent.propTypes = {
    className: PropTypes.string.isRequired,
    text: PropTypes.string,
    type: PropTypes.string,
    id: PropTypes.string,
    clickHandler: PropTypes.func,
    bootstrapButton: PropTypes.elementType,
    ariaControls: PropTypes.string,
    ariaExpanded: PropTypes.bool,
    children: PropTypes.node,
    disabled: PropTypes.bool,
};
